module.exports = __webpack_public_path__ + "static/media/banner.def3d7c1.png";